import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postThanetCouncilForms } from "../../redux/actions/thanetCouncilActions";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";

const InductionSignoffForm = ({ appData, postThanetCouncilFormsFunc }) => {
  const initialData = {
    signature: `${appData.firstName} ${appData.lastName}`,
    name: `${appData.firstName} ${appData.lastName}`,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <div>
          <p className={"mb-2"}>
            It is our policy that the health and safety of our team members
            takes priority over all other considerations. We will take every
            reasonable and practicable measure to achieve this objective.
          </p>
          <ul className={"mb-2"}>
            <li className={"mb-1"}>Introduction to HRGO</li>
            <li className={"mb-1"}>Workwear (PPE)</li>
            <li className={"mb-1"}>Conduct</li>
            <li className={"mb-1"}>Reporting Lateness/Sickness</li>
            <li className={"mb-1"}>Timesheet-how to complete</li>
            <li className={"mb-1"}>Holiday</li>
            <li className={"mb-1"}>Break Times/Rest breaks</li>
            <li className={"mb-1"}>Smoking Policy</li>
            <li className={"mb-1"}>Accident Reporting procedures</li>
            <li className={"mb-1"}>Complaints Procedure</li>
            <li className={"mb-1"}>Manual Handling</li>
            <li className={"mb-1"}>Risk Assessments</li>
            <li>Toolbox talk</li>
          </ul>
          <p>
            I confirm that I have received, read and understood information on
            all of the above, in preparation for my assignment with HRGO at
            Thanet District Council and am confident that I have all the
            information I need to prepare for work.
          </p>
        </div>
      ),
    },
    signature: {
      type: "text",
      title: "Signed",
      value: getVal("signature"),
      disabled: true,
    },
    name: {
      type: "text",
      title: "Print Name",
      value: getVal("name"),
      disabled: true,
    },
    date: {
      type: "text",
      title: "Date",
      value: getVal("date"),
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const submitted =
    appData.thanetCouncilOnboarding &&
    appData.thanetCouncilOnboarding.inductionSignoff;

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postThanetCouncilFormsFunc("inductionSignoff", {
      ...fieldValuesPayload,
      date: moment().toISOString(),
    });
    history.push("/profile/edit/thanet-council-onboarding");
  };

  const redirectBack = () => {
    history.push("/profile/edit/thanet-council-onboarding");
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Induction Signoff"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"thanetCouncil"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

InductionSignoffForm.propTypes = {
  appData: any,
  postThanetCouncilFormsFunc: func,
};

const mapDispatchToProps = {
  postThanetCouncilFormsFunc: postThanetCouncilForms,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(InductionSignoffForm);
